import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-refund-bill.reducer';

export const PharmacyRefundBillDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyRefundBillEntity = useAppSelector(state => state.pharmacyRefundBill.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyRefundBillDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.detail.title">PharmacyRefundBill</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.id}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.billNumber}</dd>
          <dt>
            <span id="billDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.billDate">Bill Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.billDate}</dd>
          <dt>
            <span id="refundAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.refundAmount">Refund Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.refundAmount}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.totalCost}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.lastupdated}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.sgst}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.patientType}</dd>
          <dt>
            <span id="printed">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.printed">Printed</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.printed ? 'true' : 'false'}</dd>
          <dt>
            <span id="printCount">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.printCount">Print Count</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.printCount}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.voidedDate}</dd>
          <dt>
            <span id="roundOffVal">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.roundOffVal">Round Off Val</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.roundOffVal}</dd>
          <dt>
            <span id="billFor">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.billFor">Bill For</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.billFor}</dd>
          <dt>
            <span id="billForId">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.billForId">Bill For Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.billForId}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.status">Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillEntity.status}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.pharmacy ? pharmacyRefundBillEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.glucoUser ? pharmacyRefundBillEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.pharmacist">Pharmacist</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.pharmacist ? pharmacyRefundBillEntity.pharmacist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.saleBill">Sale Bill</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.saleBill ? pharmacyRefundBillEntity.saleBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.returnBill ? pharmacyRefundBillEntity.returnBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.admission">Admission</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.admission ? pharmacyRefundBillEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.consumer">Consumer</Translate>
          </dt>
          <dd>{pharmacyRefundBillEntity.consumer ? pharmacyRefundBillEntity.consumer.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-refund-bill" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-refund-bill/${pharmacyRefundBillEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyRefundBillDetail;
